import { TXGUISection } from "../../interfaces/gui/fields.interfaces";
import { ELEMENTS_GUI_FIELDS } from "./elements.settings";

export const X_MAP_GUI_FIELDS: TXGUISection = {
  Données: [
    {
      type: "text",
      name: "src",
      label: "Lien Google Map",
    },
  ],

  ...ELEMENTS_GUI_FIELDS,
};
